// extracted by mini-css-extract-plugin
module.exports = {"entrance":"entrance_entrance__3Iof3","main":"entrance_main__SqHSD"};